import { ProductType, Subscription } from '@localstack/types';

export type UsageMetric = {
  type: ProductType;
  title: string;
};

const METRICS: UsageMetric[] = [
  { type: ProductType.COMPUTE_USAGE, title: 'Sandbox Credits' },
  { type: ProductType.POD_USAGE, title: 'Cloud Pods' },
  { type: ProductType.CI_USAGE, title: 'CI Credits' },
  { type: ProductType.SEATS, title: 'Seats' },
];

export const metricColumns = (subscriptions: Subscription[], hasComputeUsage: boolean): UsageMetric[] =>
  METRICS.filter(
    ({ type }) =>
      (type !== ProductType.COMPUTE_USAGE || hasComputeUsage) &&
      subscriptions.some((subscription) => subscription.products.some((product) => product.type === type)),
  );
